var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online-account-dialog-container"},[_c('div',{staticClass:"box-container"},[_c('h3',[_vm._v("töltsd le a K&H számlanyitás alkalmazást")]),_c('div',{staticClass:"qr-code-container"},[_c('img',{attrs:{"src":_vm.qrCode,"alt":"QR","height":"180px"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }